import { render } from "./App.vue?vue&type=template&id=bb77ad50"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bb77ad50&lang=css"

import exportComponent from "/Users/twchou/workspace/work/csunion/highschool_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__